import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import OfflineBonusSkillNode from "./OfflineBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class OfflineBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     */
    constructor(totals, values) {
        super(SkillIds.OFFLINE_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 10;
        let cost = 10;

        const offlineBonus1 = this.addNode(new OfflineBonusSkillNode('offlineBonus1', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus2 = this.addNode(new OfflineBonusSkillNode('offlineBonus2', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus3 = this.addNode(new OfflineBonusSkillNode('offlineBonus3', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus4 = this.addNode(new OfflineBonusSkillNode('offlineBonus4', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus5 = this.addNode(new OfflineBonusSkillNode('offlineBonus5', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus6 = this.addNode(new OfflineBonusSkillNode('offlineBonus6', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus7 = this.addNode(new OfflineBonusSkillNode('offlineBonus7', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus8 = this.addNode(new OfflineBonusSkillNode('offlineBonus8', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus9 = this.addNode(new OfflineBonusSkillNode('offlineBonus9', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus10 = this.addNode(new OfflineBonusSkillNode('offlineBonus10', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus11 = this.addNode(new OfflineBonusSkillNode('offlineBonus11', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus12 = this.addNode(new OfflineBonusSkillNode('offlineBonus12', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));


        cost += inc;

        const offlineBonus13 = this.addNode(new OfflineBonusSkillNode('offlineBonus13', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus14 = this.addNode(new OfflineBonusSkillNode('offlineBonus14', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus15 = this.addNode(new OfflineBonusSkillNode('offlineBonus15', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus16 = this.addNode(new OfflineBonusSkillNode('offlineBonus16', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus17 = this.addNode(new OfflineBonusSkillNode('offlineBonus17', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus18 = this.addNode(new OfflineBonusSkillNode('offlineBonus18', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus19 = this.addNode(new OfflineBonusSkillNode('offlineBonus19', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus20 = this.addNode(new OfflineBonusSkillNode('offlineBonus20', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));

        cost += inc;

        const offlineBonus21 = this.addNode(new OfflineBonusSkillNode('offlineBonus21', 
            totals, Images.offline, new BigNum(cost), this, this.values
        ));
        


        offlineBonus1.addChildNode(offlineBonus2);
        offlineBonus2.addChildNode(offlineBonus3);
        offlineBonus3.addChildNode(offlineBonus4);
        offlineBonus4.addChildNode(offlineBonus5);
        offlineBonus5.addChildNode(offlineBonus6);
        offlineBonus6.addChildNode(offlineBonus7);
        offlineBonus7.addChildNode(offlineBonus8);

        offlineBonus8.addChildNode(offlineBonus9);
        offlineBonus9.addChildNode(offlineBonus10);
        offlineBonus10.addChildNode(offlineBonus11);
        offlineBonus11.addChildNode(offlineBonus12);
        offlineBonus12.addChildNode(offlineBonus13);
        offlineBonus13.addChildNode(offlineBonus14);
        offlineBonus14.addChildNode(offlineBonus15);

        offlineBonus15.addChildNode(offlineBonus16);
        offlineBonus16.addChildNode(offlineBonus17);
        offlineBonus17.addChildNode(offlineBonus18);
        offlineBonus18.addChildNode(offlineBonus19);
        offlineBonus19.addChildNode(offlineBonus20);
        offlineBonus20.addChildNode(offlineBonus21);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = 4;
        const startY = -11;

        offlineBonus1.setPosition(startX, startY);
        offlineBonus2.setPosition(startX + 1, startY);
        offlineBonus3.setPosition(startX + 2, startY);
        offlineBonus4.setPosition(startX + 3, startY);
        offlineBonus5.setPosition(startX + 4, startY);
        offlineBonus6.setPosition(startX + 5, startY);
        offlineBonus7.setPosition(startX + 6, startY);

        offlineBonus8.setPosition(startX + 6, startY - 1);
        offlineBonus9.setPosition(startX + 5, startY - 1);
        offlineBonus10.setPosition(startX + 4, startY - 1);
        offlineBonus11.setPosition(startX + 3, startY - 1);
        offlineBonus12.setPosition(startX + 2, startY - 1);
        offlineBonus13.setPosition(startX + 1, startY - 1);
        offlineBonus14.setPosition(startX, startY - 1);

        offlineBonus15.setPosition(startX, startY - 2);
        offlineBonus16.setPosition(startX + 1, startY - 2);
        offlineBonus17.setPosition(startX + 2, startY - 2);
        offlineBonus18.setPosition(startX + 3, startY - 2);
        offlineBonus19.setPosition(startX + 4, startY - 2);
        offlineBonus20.setPosition(startX + 5, startY - 2);
        offlineBonus21.setPosition(startX + 6, startY - 2);

    }
    
}